/* ==========================================================================
   nb-card-variants.js — størrelsesvælgeren på produktkortet

   Hører til snippets/product-card.liquid, når kortet renderes med
   show_variants: true. Kortet leverer al tekst som data-attributter — der
   står IKKE ét dansk ord i denne fil.

   Kontrakt (sat i product-card.liquid):
     [data-nb-product-card]            kortets rod. Alt slås op indenfor den.
     [data-nb-card-variants]           chip-gruppen. Bærer labels:
                                         data-nb-label-stock
                                         data-nb-label-preorder
                                         data-nb-label-add
                                         data-nb-label-preorder-add
                                         data-nb-label-save  ("SPAR [pct]%")
     [data-nb-card-variant="<id>"]     én chip pr. variant. Bærer:
                                         data-nb-price     (formateret pris)
                                         data-nb-compare   (førpris, valgfri)
                                         data-nb-save      (procent, valgfri)
                                         data-nb-preorder  ("true"/"false")
     [data-nb-card-stock]              lagerlinjen (● PÅ LAGER / FORUDBEST.)
     [data-nb-card-price]              .nb-price-wrapperen med
                                         [data-nb-price-current]
                                         [data-nb-price-compare]
                                         [data-nb-price-save]
     [data-nb-quickadd]                CTA'en. Selve tilføj-til-kurv-flowet
                                       ejes af nb-cart.js, som læser
                                       data-nb-quickadd på klik-tidspunktet.
                                       Vi skifter kun attributten og labelen.

   Lytteren er delegeret fra document og bindes én gang, så kort indsat af
   "Vis flere" (nb-collection.js) virker uden ny opsætning.
   ========================================================================== */

(function () {
  'use strict';

  if (window.NBCardVariants && window.NBCardVariants.__ready) return;

  var CARD = '[data-nb-product-card]';
  var GROUP = '[data-nb-card-variants]';
  var CHIP = '[data-nb-card-variant]';

  function closest(el, selector) {
    if (!el || !el.closest) return null;
    return el.closest(selector);
  }

  function attr(el, name) {
    if (!el) return '';
    var value = el.getAttribute(name);
    return value === null ? '' : value;
  }

  /* ------------------------------------------------------------------------
     Lagerlinjen — "på lager" eller "forudbestilling"
     ---------------------------------------------------------------------- */
  function setStock(card, group, isPreorder) {
    var stock = card.querySelector('[data-nb-card-stock]');
    if (!stock) return;

    var label = attr(group, isPreorder ? 'data-nb-label-preorder' : 'data-nb-label-stock');
    if (label) stock.textContent = label;
    stock.setAttribute('data-nb-preorder', isPreorder ? 'true' : 'false');
  }

  /* ------------------------------------------------------------------------
     Prisen — pris, førpris og SPAR følger den valgte variant.
     Elementerne findes altid i DOM'en (skjult), så der bygges ingen markup.
     ---------------------------------------------------------------------- */
  function setPrice(card, group, chip) {
    var price = card.querySelector('[data-nb-card-price]');
    if (!price) return;

    var current = price.querySelector('[data-nb-price-current]');
    var value = attr(chip, 'data-nb-price');
    if (current && value) current.textContent = value;

    var compareValue = attr(chip, 'data-nb-compare');
    var compare = price.querySelector('[data-nb-price-compare]');
    if (compare) {
      compare.textContent = compareValue;
      compare.hidden = !compareValue;
    }

    var save = price.querySelector('[data-nb-price-save]');
    if (save) {
      var percent = attr(chip, 'data-nb-save');
      var template = attr(group, 'data-nb-label-save');
      if (percent && template) {
        save.textContent = template.replace('[pct]', percent);
        save.hidden = false;
      } else {
        save.textContent = '';
        save.hidden = true;
      }
    }

    if (compareValue) price.classList.add('nb-price--onsale');
    else price.classList.remove('nb-price--onsale');
  }

  /* ------------------------------------------------------------------------
     CTA'en — ny variant-id og evt. ny label ("forudbestil").
     Er knappen midt i et tilføj-forløb (data-nb-state), lader vi teksten
     være; nb-cart.js sætter den tilbage til data-nb-label-default bagefter.
     ---------------------------------------------------------------------- */
  function setButton(card, group, chip, isPreorder) {
    var button = card.querySelector('[data-nb-quickadd]');
    if (!button) return;

    var variantId = attr(chip, 'data-nb-card-variant');
    if (variantId) button.setAttribute('data-nb-quickadd', variantId);

    var label = attr(group, isPreorder ? 'data-nb-label-preorder-add' : 'data-nb-label-add');
    if (!label) return;

    button.setAttribute('data-nb-label-default', label);
    if (!button.getAttribute('data-nb-state')) button.textContent = label;
  }

  /* ------------------------------------------------------------------------
     Valget
     ---------------------------------------------------------------------- */
  function select(chip) {
    if (!chip || chip.disabled || chip.getAttribute('aria-disabled') === 'true') return;

    var group = closest(chip, GROUP);
    var card = closest(chip, CARD);
    if (!group || !card) return;
    if (chip.getAttribute('aria-pressed') === 'true') return;

    var chips = group.querySelectorAll(CHIP);
    for (var i = 0; i < chips.length; i++) {
      var active = chips[i] === chip;
      chips[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) chips[i].classList.add('is-active');
      else chips[i].classList.remove('is-active');
    }

    var isPreorder = attr(chip, 'data-nb-preorder') === 'true';

    setStock(card, group, isPreorder);
    setPrice(card, group, chip);
    setButton(card, group, chip, isPreorder);
  }

  /* ------------------------------------------------------------------------
     Delegeret lytter — bindes én gang på document
     ---------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    var chip = closest(event.target, CHIP);
    if (!chip) return;
    select(chip);
  });

  window.NBCardVariants = {
    __ready: true,
    select: select
  };
})();
